import React from "react";
import { useEffect } from "react";

import { useDispatch, useStore } from "../../../store";
import { MainSpinner } from "../../../components";
import { Spinner } from "discover.medical.react-component-library";
import {
  DrugInteractionsPolicy,
  DrugInteractionsChecker,
  DrugInteractionsError,
  DrugInteractionsResults,
} from "../../../components/DrugInteractions";
import { DrugInteractionContainer } from "./styled";
import {
  fetchDrugInteractionsViewModel,
  setInteractingDrugDetails,
} from "../../../store/drug-interactions/actions";
import { useHistory } from "react-router-dom";

const DrugInteractionsLayout = () => {
  const dispatch = useDispatch();
  const { drugInteractions } = useStore();
  const history = useHistory();
  const {
    isFetching,
    isResultsFetching,
    drugInteractionsViewModel,
    checkerErrorViewModel,
    resultsViewModel,
    resultsErrorViewModel,
  } = drugInteractions;

  useEffect(() => {
    if (!drugInteractionsViewModel) {
      fetchDrugInteractionsViewModel(dispatch);
    }
  }, [dispatch, drugInteractionsViewModel]);

  if (isFetching) {
    return <MainSpinner />;
  }

  if (checkerErrorViewModel) {
    return <DrugInteractionsError viewModel={checkerErrorViewModel} />;
  }

  if (drugInteractionsViewModel?.termsContent) {
    return <DrugInteractionsPolicy viewModel={drugInteractionsViewModel} />;
  }

  const handleItemClick = (data) => {
    setInteractingDrugDetails(dispatch, data);
    history.push(`/browse/drug-interactions/${data.interactingDrugName}`);
  };

  const renderResults = () => {
    if (resultsErrorViewModel) {
      return <DrugInteractionsError viewModel={resultsErrorViewModel} />;
    }

    if (isResultsFetching) {
      return <Spinner size="lg" />;
    }
    if (!resultsViewModel) {
      return null;
    }

    return (
      <DrugInteractionsResults
        viewModel={resultsViewModel}
        handleItemClick={handleItemClick}
      />
    );
  };

  return (
    <>
      {drugInteractionsViewModel?.content && (
        <DrugInteractionContainer data-testid="drug-interactions-root">
          <DrugInteractionsChecker viewModel={drugInteractionsViewModel} />
          {renderResults()}
        </DrugInteractionContainer>
      )}
    </>
  );
};

export default DrugInteractionsLayout;
